var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("" + (_vm.vertical ? 'divider-vertical' : 'divider-horizontal'))],style:({width: _vm.width, height: _vm.height, background: ("linear-gradient(to " + (_vm.vertical ? 'right' : 'bottom') + ", transparent 0%, " + _vm.color + " 50%, transparent 100%)")})})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e1e3c5b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/divider.vue
// module id = null
// module chunks = 